/* import __COLOCATED_TEMPLATE__ from './conversation-panel.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export interface ConversationExploreConversation {
  id: number;
  userName: string;
  userPseudonym: string;
  topicSummary: string;
  subtopic: string;
  topic: string;
  cxExplanation: string;
  cxScore: number;
}

interface Args {
  loadedConversations: ConversationExploreConversation[];
  initialSelectedConversationId?: number;
  totalHits: number;
  loadMoreConversations: () => void;
  isLoadingMore: boolean;
  conversationFetchError: any;
  isStandalone: boolean;
  trackAnalyticsEvent: (action: string, object: string, extraContext: Record<string, any>) => void;
  hideCXWhenMissing?: boolean;
}

export default class ConversationPanel extends Component<Args> {
  @tracked selectedConversationId = this.args.initialSelectedConversationId ?? 0;

  get drillInPermissionError() {
    return this.args.conversationFetchError?.errorThrown === 'Forbidden';
  }

  get selectedConversationCXExplanation() {
    return this.args.loadedConversations.find(
      (conversation) => conversation.id === this.selectedConversationId,
    )?.cxExplanation;
  }

  get selectedConversationCXScore() {
    return this.args.loadedConversations.find(
      (conversation) => conversation.id === this.selectedConversationId,
    )?.cxScore;
  }

  get conversationIds() {
    return this.args.loadedConversations.map((conversation) => conversation.id);
  }

  get hasMoreConversations() {
    return this.args.loadedConversations.length < this.args.totalHits;
  }

  @action
  onConversationSelected(conversationId: number) {
    this.selectedConversationId = conversationId;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::ConversationPanel': typeof ConversationPanel;
    'reporting/automation/ai-insights/conversation-panel': typeof ConversationPanel;
  }
}
